import {
  UserSubscription,
  ChannelType,
  SUBSCRIPTION_TYPES,
  IRegistrationAddress,
} from '@agco-onedigital/ecosystem-lib-frontend-utils';

export const toContactPointTypeConsents = (consents: UserSubscription[]) => {
  const optedInChannels = new Set(consents.filter(c => c.status === 'Opt In').map(c => c.channelType));

  const allContactPointTypes = ['Email', 'Phone', 'MailingAddress', 'SMS'] as ChannelType[];

  const result = allContactPointTypes
    .filter(t => optedInChannels.has(t))
    .map(t => ({
      contactPointType: t,
      captureSource: 'CEP',
      status: 'Opt In',
    }));

  return result;
};

export const mapSubscriptions = (subscriptions: UserSubscription[] | undefined) =>
  subscriptions?.map(({ brand, channelType, type, status }) => {
    const normalizedType = SUBSCRIPTION_TYPES[type] || type;
    const commSubscriptionChannelType = `${brand}_${channelType}_${normalizedType}_Consent_Based`;
    return {
      captureSource: 'CEP',
      status,
      commSubscriptionChannelType,
    };
  }) ?? [];

export const AUTHORIZAZION_FORM_CONSENTS = [
  {
    authorizationForm: 'AGCO_Data_Privacy_Policy',
    captureSourceType: 'Web',
    captureDateTime: new Date().toISOString(),
    captureSource: 'Multibrand Registration Form',
    status: 'Seen',
  },
];

export const EMPTY_ADDRESS: IRegistrationAddress = {
  addressLine1: '',
  country: '',
  city: '',
  stateProvinceName: '',
  postalCode: '',
};

export const getPhone = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return [];
  const newDate = new Date().toISOString().slice(0, 10);
  return [
    {
      telephoneNumber: phoneNumber,
      contactPointType: 'ContactPointPhone',
      primaryFlag: true,
      activeFromDate: newDate,
      activeToDate: newDate,
    },
  ];
};

export const mapAddressData = (address: IRegistrationAddress | undefined) => {
  return {
    addressLine1: address?.addressLine1,
    countryCode: address?.country,
    cityName: address?.city,
    stateProvinceName: address?.state ?? '',
    postalCodeText: address?.postalCode,
    contactPointType: 'ContactPointAddress',
    primaryFlag: true,
    activeFromDate: new Date().toISOString().slice(0, 10),
  };
};
